import "reflect-metadata";
import { ModuleRef } from "./module";
export * from "./decorators";
export * from "./module";
export * from "./provider";
export function createModule(module) {
    return ModuleRef.create(module);
}
//# sourceMappingURL=index.js.map